import { UpdateServiceConfig } from "../types/update.types";
import { UpdateService } from "../service/Update.service";

import { getConfigFromScript } from "./getConfigFromScript";
import { defaultConfig, DEFAULT_MESSAGES } from "./defaultConfig";

export function initializeUpdater() {
  // Add automatic initialization
  document.addEventListener("DOMContentLoaded", autoInitializeUpdater);
}

function autoInitializeUpdater() {
  const script = document.getElementById("autoupdater");

  if (!script || !(script instanceof HTMLScriptElement)) {
    return;
  }

  initUpdater(getConfigFromScript(script));
}

export function initUpdater(config: Partial<UpdateServiceConfig>) {
  const finalConfig = {
    ...defaultConfig,
    ...config,
    messages: { ...DEFAULT_MESSAGES, ...config.messages },
  };

  const updateService = new UpdateService(finalConfig);
  updateService.start();
}
